import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Button from "components/library/Button";
import Icon from "components/library/Icon";
import InstoryNewsletterCTAPopover from "./InstoryNewsletterCTAPopover";

import styles from "./InstoryNewsletterCTA.css";

export default class InstoryNewsletterCTA extends React.Component {
  constructor(props) {
    super(props);
    this.promoRef = React.createRef();
    this.state = {
      isActive: false,
    };
    this.activate = this._activate.bind(this);
    this.deactivate = this._deactivate.bind(this);
  }

  _activate() {
    this.setState({ isActive: true });
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
  }

  _deactivate() {
    this.setState({ isActive: false });
  }

  render() {
    const promo = this.props.promotion;

    return (
      <div
        className={styles.root}
        style={{ backgroundColor: promo.background_color }}
        onClick={this.activate}
        ref={this.promoRef}
      >
        <InstoryNewsletterCTAPopover
          closeModal={this.deactivate}
          CTA_Element={this.promoRef.current}
          isActive={this.state.isActive}
        />
        <div className={styles.left}>
          <h3 className={styles.title}> {promo.title}</h3>
          <span className={styles.tagline}>{promo.content}</span>
          <div className={styles.form_wrapper}>
            <input
              type="email"
              value=""
              placeholder={promo.placeholder || "Type your email"}
              className={styles.input}
              disabled
            />
            <Button
              isDisabled={true}
              className={styles.button}
              onClick={() => {}}
            >
              <Icon
                className={classNames(styles.icon, styles.chevron)}
                name="chevron/right"
                description=""
              />
            </Button>
          </div>
        </div>
        {promo.image && (
          <div className={styles.right}>
            <img src={promo.image} className={styles.image} />
          </div>
        )}
      </div>
    );
  }
}

InstoryNewsletterCTA.propTypes = {
  promotion: PropTypes.shape({
    background_color: PropTypes.string,
    title: PropTypes.string.isRequired,
    content: PropTypes.string,
    placeholder: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
};
